import "PFCore/initializers/set_storage";

import extend from "lodash/extend";
import isNil from "lodash/isNil";

const envConfig = {
  api_endpoint: import.meta.env.VITE_API_ENDPOINT,
  development_domain: import.meta.env.VITE_DEVELOPMENT_DOMAIN,
  pusher_key: import.meta.env.VITE_PUSHER_KEY,
  client_id: import.meta.env.VITE_CLIENT_ID,
  environment: import.meta.env.VITE_ENVIRONMENT,
  datadog_environment: import.meta.env.VITE_DATADOG_ENVIRONMENT,
  pusher_host: import.meta.env.VITE_PUSHER_HOST,
  pusher_cluster: import.meta.env.VITE_PUSHER_CLUSTER,
  force_ssl: import.meta.env.VITE_FORCE_SSL,
  datadog_application_id: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  datadog_client_token: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  datadog_site: import.meta.env.VITE_DATADOG_SITE,
  chameleon_token: import.meta.env.VITE_CHAMELEON_TOKEN,
  ui_version: import.meta.env.VITE_UI_VERSION,
  ui_branch: import.meta.env.VITE_UI_BRANCH,
  documentation_url: import.meta.env.VITE_DOCUMENTATION_URL || "https://knowledge.hub.profinda.com",
  enable_react_query_dev_tools: import.meta.env.VITE_ENABLE_REACT_QUERY_DEV_TOOLS === "true",
  ms_teams_default_domain: import.meta.env.VITE_MS_TEAMS_DEFAULT_DOMAIN
};

const STORAGE_KEY = "profinda_custom_configuration";

const getDevConfig = () => {
  const customConfig = storage.getItem(STORAGE_KEY);
  if (customConfig) {
    return extend(envConfig, customConfig);
  }

  return envConfig;
};

const getProdConfig = () => {
  const { locale } = storage.getItem(STORAGE_KEY) || {};

  if (isNil(locale)) {
    return envConfig;
  }

  return extend(envConfig, { locale });
};

export const getConfig = () => {
  if (["development", "staging", "multistaging"].includes(envConfig.environment)) {
    return getDevConfig();
  }

  return getProdConfig();
};

export default envConfig;
